module.exports = __webpack_public_path__ + "img/icon-warning.102690b0.svg";